<template>
  <div>
    <h1 class="text-headline-small text-md-display-medium text-lg-display-large text-xl-display-large text-truncate">
      Outils de données
    </h1>
    <v-container class="pt-6">
      <v-row>
        <v-col cols="12" md="8">
          <v-card variant="outlined">
            <v-card-title>Sécuriser les topos et les caméras</v-card-title>
            <v-card-text>
              Déplace chaque carte topo dans un nouveau dossier et retire les jetons de téléchargement des topos et des
              photos des caméras : les anciens liens publics cessent de fonctionner. Le site affiche ensuite ces images
              avec des liens temporaires, réservés aux membres (et à tous pour les sections gratuites). Peut être
              relancé sans danger.
            </v-card-text>
            <v-card-actions>
              <v-btn variant="flat" color="secondary" :loading="isLoading" @click="secureMediaFiles()">
                Sécuriser les fichiers
              </v-btn>
            </v-card-actions>
            <v-alert v-if="result" type="success" variant="tonal" class="ma-4 mt-0">
              {{ result.topos }} topos déplacées, {{ result.toposMissing }} liens vers des fichiers introuvables
              retirés, jetons retirés de {{ result.cameraPhotos }} photos de caméras.
              <span v-if="result.errors"> {{ result.errors }} erreurs (voir les journaux de la fonction).</span>
            </v-alert>
            <v-alert v-if="errorMessage" type="error" variant="tonal" class="ma-4 mt-0">{{ errorMessage }}</v-alert>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { functions } from "@/firebase";

  export default {
    data() {
      return {
        isLoading: false,
        result: null,
        errorMessage: "",
      };
    },
    methods: {
      // functions/includes/mediaFunctions.js, issue #104
      async secureMediaFiles() {
        this.isLoading = true;
        this.result = null;
        this.errorMessage = "";
        try {
          const response = await functions.httpsCallable("secureMediaFiles", { timeout: 540000 })();
          this.result = response.data;
        } catch (error) {
          console.error("secureMediaFiles failed:", error);
          this.errorMessage = "La sécurisation a échoué : " + (error.message || error);
        } finally {
          this.isLoading = false;
        }
      },
    },
  };
</script>
